import HistorialMovimientosCliente from 'akasia-components/cliente/HistorialMovimientosCliente';
import ErrorBoundary from 'components/common/ErrorBoundary';
import PageHeader from 'components/common/PageHeader';
import { useToast } from 'context/providers/ToastProvider';
import React, { useEffect } from 'react';
import { Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ModalSeguimientoLead from '../leads/ModalSeguimientoLead';
import ModalDatosFiscalesIncompletos from './ModalDatosFiscalesIncompletos';
import OrdenesCliente from './OrdenesCliente';
import SeccionArchivosCliente from './SeccionArchivo';
import SoporteTecnico from './seccion-soporte-tecnico/SoporteTecnico';

// Componentes nuevos
import SeccionSuscripciones from '../suscripciones/SeccionSuscripciones';
import ClienteHeader from './components/ClienteHeader';
import ClientesRepetidos from './components/ClientesRepetidos';
import DetallesContactoFiscal from './components/DetallesContactoFiscal';
import DetallesInformacionContacto from './components/DetallesInformacionContacto';
import InformacionGeneral from './components/InformacionGeneral';
import LeadsVinculados from './components/LeadsVinculados';
import ModalCombinarClientes from './components/ModalCombinarClientes';
import ModalEliminarCliente from './components/ModalEliminarCliente';
import ModalNuevoSoporte from './components/ModalNuevoSoporte';
import PlanesFacturacionMx from './components/PlanesFacturacionMx';
import ServiciosContratados from './components/ServiciosContratados';
import SkeletonCargandoInformacionContactoFiscal from './components/SkeletonCargandoInformacionContactoFiscal';

// Hooks personalizados
import useClienteDetalles from './hooks/useClienteDetalles';
import useClienteForms from './hooks/useClienteForms';
import useClienteOperaciones from './hooks/useClienteOperaciones';
import useModales from './hooks/useModales';

const DetallesCliente = () => {
    const { id } = useParams();

    // Hook para formularios
    const { formPrincipal, formSoporte } = useClienteForms();


    // Hook para modales
    const {
        showModalNuevoSoporte,
        showModalEliminar,
        showModalCombinarClientes,
        showModalSeguimientoLead,
        showModalDatosFiscalesIncompletos,
        setShowModalEliminar,
        setShowModalSeguimientoLead,
        abrirModalNuevoSoporte,
        cerrarModalNuevoSoporte,
        cerrarModalEliminar,
        abrirModalDatosFiscalesIncompletos,
        cerrarModalCombinarClientes,
        setShowModalCombinarClientes,
        setShowModalDatosFiscalesIncompletos
    } = useModales();


    // Hook para manejar la lógica del cliente
    const {
        customerdetails,
        agrupacionLicencias,
        tablaRegimenFiscal,
        tablaUsoCFDI,
        countries,
        states,
        nivelSoporte,
        herramientas,
        isDistribucion,
        setIsDistribucion,
        statusSolucion,
        soporte,
        ordenes,
        setOrdenes,
        documentosCargados,
        setDocumentosCargados,
        documentos,
        cargando,
        cargandoEstado,
        cargandoFile,
        editar,
        setEditar,
        editando,
        cargandoComboBoxSoporte,
        licencias,
        polizas,
        dataFiles,
        setDataFiles,
        leadsVinculados,
        setLeadsVinculados,
        clienteActivityLogs,
        setClienteActivityLogs,
        clientesRepetidos,
        getinformaciondetalladaclientebyid,
        obtenerComboBoxSoporteTecnico,
        mostrarEstados,
        editarInfoCliente,
        eliminarCliente,
        registrarSoporteTecnico,
        combinarClientes,
        onSubmitDocFile
    } = useClienteDetalles(id);

    // Hook para operaciones del cliente
    const {
        setIdClienteAkasiaACombinar,
        habilitarBtnCombinar,
        idLead,
        setIdLead,
        validarDatosFiscales,
        handleObtenerComboBoxSoporteTecnico,
        handleGuardarCliente,
        handleRegistrarSoporte,
        handleEliminarCliente,
        handleCombinarClientes,
        mensajeDatosFiscales
    } = useClienteOperaciones({
        customerdetails,
        editarInfoCliente,
        eliminarCliente,
        registrarSoporteTecnico,
        combinarClientes,
        obtenerComboBoxSoporteTecnico,
        abrirModalDatosFiscalesIncompletos,
        abrirModalNuevoSoporte,
        cerrarModalNuevoSoporte,
        cerrarModalEliminar,
        cerrarModalCombinarClientes,
        resetFormSoporte: formSoporte.reset
    });

    const { showErrorToast } = useToast();

    useEffect(() => {
        const fetchData = async () => {
            try {
                await getinformaciondetalladaclientebyid();
            } catch (error) {
                showErrorToast(error.message || 'Error al cargar la información del cliente');
            }
        };
        fetchData();
    }, [id]);
    const [paisSeleccionado, setPaisSeleccionado] = React.useState(customerdetails.vPais || 'Mexico');
    const handlePaisChange = (event) => {
        const nuevoPais = event.target.value;

        setPaisSeleccionado(nuevoPais);
        mostrarEstados(nuevoPais);
    };

    // Wrapper para onSubmit del formulario principal
    const onSubmit = (data) => handleGuardarCliente(id, data);

    return (
        <>
            <PageHeader
                title={"Cliente " + id + " | Informaci\u00f3n detallada"}
                className="mb-1"
            />
            {cargando ? (
                <h3>
                    <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                </h3>
            ) : (
                <>
                    <ClienteHeader
                        customerdetails={customerdetails}
                        editar={editar}
                        editando={editando}
                        setEditar={setEditar}
                        handleSubmit={formPrincipal.handleSubmit}
                        onSubmit={onSubmit}
                        reset={formPrincipal.reset}
                        ordenes={ordenes}
                        soporte={soporte}
                        validarDatosFiscales={validarDatosFiscales}
                        obtenerComboBoxSoporteTecnico={handleObtenerComboBoxSoporteTecnico}
                        setShowModalEliminar={setShowModalEliminar}
                    />

                    <Form noValidate onSubmit={formPrincipal.handleSubmit(onSubmit)}>
                        <Row className="g-3 mb-3">
                            <Col lg={12}>
                                <InformacionGeneral
                                    customerdetails={customerdetails}
                                    editar={editar}
                                    editando={editando}
                                    register={formPrincipal.register}
                                    errors={formPrincipal.errors}
                                    ordenes={ordenes}
                                    soporte={soporte}
                                />


                            </Col>

                            <Col lg={12}>
                                <Card>
                                    <Card.Header>
                                        <Row className="align-items-center">
                                            <Col>
                                                <h5 className="mb-0">Detalles</h5>
                                            </Col>
                                            <Col xs="auto"></Col>
                                        </Row>
                                    </Card.Header>

                                    <Card.Body className="border-top fs--1">
                                        {editando ? (
                                            <SkeletonCargandoInformacionContactoFiscal />
                                        ) : (
                                            <Row>
                                                {/* Información de Contacto */}
                                                <DetallesInformacionContacto
                                                    customerdetails={customerdetails}
                                                    editar={editar}
                                                    register={formPrincipal.register}
                                                    errors={formPrincipal.errors}
                                                    countries={countries}
                                                    states={states}
                                                    cargandoEstado={cargandoEstado}
                                                    mostrarEstados={mostrarEstados}
                                                    documentos={documentos}
                                                    documentosCargados={documentosCargados}
                                                    dataFiles={dataFiles}
                                                    setDataFiles={setDataFiles}
                                                    setDocumentosCargados={setDocumentosCargados}
                                                    onSubmitDocFile={onSubmitDocFile}
                                                    cargandoFile={cargandoFile}
                                                    handlePaisChange={handlePaisChange}
                                                />

                                                {/* Información Fiscal */}
                                                <DetallesContactoFiscal
                                                    customerdetails={customerdetails}
                                                    editar={editar}
                                                    register={formPrincipal.register}
                                                    errors={formPrincipal.errors}
                                                    setValue={formPrincipal.setValue}
                                                    tablaRegimenFiscal={tablaRegimenFiscal}
                                                    tablaUsoCFDI={tablaUsoCFDI}
                                                    isDistribucion={isDistribucion}
                                                    setIsDistribucion={setIsDistribucion}
                                                    paisSeleccionado={paisSeleccionado}
                                                />
                                                <Col className="col-12"></Col>
                                            </Row>
                                        )}
                                    </Card.Body>
                                </Card >
                            </Col>

                            <LeadsVinculados
                                leadsVinculados={leadsVinculados}
                                setIdLead={setIdLead}
                                setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                            />
                            <ClientesRepetidos
                                clientesRepetidos={clientesRepetidos}
                                setIdClienteAkasiaACombinar={setIdClienteAkasiaACombinar}
                                setShowModalCombinarClientes={setShowModalCombinarClientes}
                            />
                        </Row>

                        {/* 🆕 NUEVA SECCIÓN: Suscripciones */}
                        <Row className="g-3 mb-2">
                            <Col lg={12}>
                                <ErrorBoundary>
                                    <SeccionSuscripciones
                                        idCliente={id}
                                    />
                                </ErrorBoundary>
                            </Col>
                        </Row>

                        <Row className="g-3 mb-2">
                            <Col lg={12}>
                                <ErrorBoundary>
                                    <PlanesFacturacionMx
                                        idCliente={id}
                                    />
                                </ErrorBoundary>
                            </Col>
                        </Row>


                        <ServiciosContratados
                            agrupacionLicencias={agrupacionLicencias}
                            licencias={licencias}
                            polizas={polizas}
                        />

                        <Row className="g-3 mb-2">
                            <Col lg={12}>
                                <ErrorBoundary>
                                    <OrdenesCliente
                                        idCliente={id}
                                        setOrdenes={setOrdenes}
                                        ordenes={ordenes}
                                    />
                                </ErrorBoundary>
                            </Col>
                        </Row>

                        <Row className="g-3 mb-3">
                            <Col lg={12}>
                                <ErrorBoundary>
                                    <SeccionArchivosCliente
                                        idCliente={id}
                                        setClienteActivityLogs={setClienteActivityLogs}
                                    />
                                </ErrorBoundary>
                            </Col>
                        </Row>

                        <ErrorBoundary>
                            <SoporteTecnico
                                agrupacionLicencias={agrupacionLicencias}
                                setHabilitarBtnCombinar={setShowModalCombinarClientes}
                                setShowModalCombinarClientes={setShowModalCombinarClientes}
                                idClienteAkasia={id}
                                emailCliente={customerdetails?.vEmail}
                            />
                        </ErrorBoundary>

                        <Row className="mb-3">
                            <Col lg={12}>
                                <ErrorBoundary>
                                    <HistorialMovimientosCliente
                                        idCliente={id}
                                        setClienteActivityLogs={setClienteActivityLogs}
                                        clienteActivityLogs={clienteActivityLogs}
                                    />
                                </ErrorBoundary>
                            </Col>
                        </Row>
                    </Form>

                    {/* Modales */}
                    <ModalNuevoSoporte
                        showModalNuevoSoporte={showModalNuevoSoporte}
                        setShowModalNuevoSoporte={cerrarModalNuevoSoporte}
                        cargandoComboBoxSoporte={cargandoComboBoxSoporte}
                        handleSubmit={formSoporte.handleSubmit}
                        onSubmitNuevoSoporte={handleRegistrarSoporte}
                        register={formSoporte.register}
                        errors={formSoporte.errors}
                        nivelSoporte={nivelSoporte}
                        herramientas={herramientas}
                        statusSolucion={statusSolucion}
                        reset={formSoporte.reset}
                    />

                    <ModalEliminarCliente
                        showModalEliminar={showModalEliminar}
                        setShowModalEliminar={setShowModalEliminar}
                        handleSubmit={formPrincipal.handleSubmit}
                        onSubmitEliminar={handleEliminarCliente}
                        reset={formPrincipal.reset}
                    />

                    <ModalCombinarClientes
                        showModalCombinarClientes={showModalCombinarClientes}
                        setShowModalCombinarClientes={setShowModalCombinarClientes}
                        customerdetails={customerdetails}
                        habilitarBtnCombinar={habilitarBtnCombinar}
                        combinarClientes={handleCombinarClientes}
                    />

                    <ModalSeguimientoLead
                        showModal={showModalSeguimientoLead}
                        setShowModal={setShowModalSeguimientoLead}
                        idLead={idLead}
                        setIdLead={setIdLead}
                        leadsVinculados={leadsVinculados}
                        setLeadsVinculados={setLeadsVinculados}
                    />

                    <ModalDatosFiscalesIncompletos
                        showModalDatosFiscalesIncompletos={showModalDatosFiscalesIncompletos}
                        setShowModalDatosFiscalesIncompletos={setShowModalDatosFiscalesIncompletos}
                        mensaje={mensajeDatosFiscales}
                    />
                </>
            )}
        </>
    );
};

export default DetallesCliente;
